import React, { useEffect } from "react";
import { Card, Container, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import makeStyles from "@mui/styles/makeStyles";
import { useHistory } from "react-router-dom";
import { userLogout } from "hfn-auth-legacy/dist/main";
import { Box } from "@mui/system";
import { getKeycloakAuthConfig } from "config/keycloak";

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function TokenExpiredComponent() {
  const history = useHistory();
  const classes = useStyles();
  const params = getKeycloakAuthConfig();

  const redirectToLogin = () => {
    window.location.replace("/#/login");
    return true;
  };

  useEffect(() => {
    const validateUser = async () => {
      const currentUser = localStorage.getItem("user");
      const userData = currentUser ? JSON.parse(currentUser) : null;
      if (userData) {
        history.replace("/app");
        return;
      } else {
        localStorage.clear();
        await userLogout(params);
      }
    };
    validateUser();
  }, []);

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card
        sx={{
          marginX: "25px",
          marginY: "10px",
          boxShadow: 3,
          width: "100%",
        }}
      >
        <Box
          m={3}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center", // Ensures text is centered
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            Session has been expired!
          </Typography>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={redirectToLogin}
            className={classes.submit}
          >
            Sign In
          </Button>
        </Box>
      </Card>
    </Container>
  );
}
